import { useEffect } from "react";
import { validatePassword, clearPasswordCache } from "../utils/passwordUtils";

export const usePasswordCheck = (onPasswordInvalid) => {
  useEffect(() => {
    const checkPassword = () => {
      if (!validatePassword()) {
        clearPasswordCache();
        if (onPasswordInvalid) {
          onPasswordInvalid();
        }
      }
    };

    // 组件加载时验证
    checkPassword();

    // 监听焦点事件，当用户切换回页面时也验证
    const handleFocus = () => {
      checkPassword();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [onPasswordInvalid]);

  // 返回一个验证函数，供组件在关键操作前调用
  const checkPasswordBeforeAction = (action) => {
    if (!validatePassword()) {
      clearPasswordCache();
      if (onPasswordInvalid) {
        onPasswordInvalid();
      }
      return false;
    }
    if (action) {
      action();
    }
    return true;
  };

  return { checkPasswordBeforeAction };
};
